import React from 'react';
import { SectionContainer } from '../../../aboutUs/styles';
import styled from 'styled-components';
import { Box, Title, VerticalBox } from '../../../../components';
import { ResultSwiper } from './ResultSwiper';
import { Result } from './Result';
import { Counter } from './Counter';
import ResultScreenshot from '../Images/ResultScreenshot';
import { sectionMockImg } from '../../../../assets/png';
import { COLORS } from '../../../../constants';

interface ResultDescriptionType {
  Title: string;
  Description: string;
  ResultImage: {
    Content: string;
  };
}
interface DivProps extends React.HTMLProps<HTMLDivElement> {
  resultDescriptions: ResultDescriptionType[];
}

export const ProjectResults: React.FC<DivProps> = ({ resultDescriptions }) => {
  return (
    <SectionContainer $color={COLORS.GRAY_BG_COLOR}>
      <Box>
        <VerticalBox>
          <Title title="Results" isAnimated={true} />
          <ResultSwiper
            data={resultDescriptions}
            renderItem={(item, index, length) => (
              <Result
                title={item.Title}
                description={item.Description}
                counter={<Counter index={index + 1} length={length} />}
                screenshot={
                  item.ResultImage?.Content ? (
                    <ResultScreenshot
                      src={item.ResultImage.Content}
                      alt={`Result Image ${index}`}
                    />
                  ) : (
                    <MockImg src={sectionMockImg} alt={'Mock Image'} />
                  )
                }
              />
            )}
          />
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};

const MockImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
